import { getGridPixel, getSelectFrame } from "@/utils/canvasUtil";
import { Track, TrackLineItem } from "./class/Track";
import { makeAutoObservable, action } from "mobx";
import {
  formatTime,
  getCurrentEditorTrackItemList,
  isOfCanPlayEditorType,
  isVideo,
} from "@/utils/tool";
import { VideoSource } from "./class/VideoTrack";
import playerStore from "@/stores/clipEditor/player";
import { EditorConfig } from "@/components/business/ClipEditor";

interface InsertInfo {
  insertIndex: number;
  itemIndex: number;
  left: number;
  right: number;
  isNewLine: boolean;
  start?: number;
  end?: number;
}

class TrackState {
  editorConfig?: EditorConfig = {
    background: "#fff",
    timeline: {
      longLineColor: "#B2B2B2",
      shortLineColor: "#CCCCCCFF",
      lineWidth: 2,
      textSize: 12,
      textColor: "#B2B2B2",
    },
    pointer: {
      lineColor: "#ab50ff",
      pointerColor: "#ab50ff",
    },
  };
  dragData = {
    dataInfo: {} as Track,
    dragType: "",
    dragPoint: {
      x: 0,
      y: 0,
    },
    // 吸附辅助线
    fixLines: [] as { position: number; frame: number }[][],
    moveX: 0,
    moveY: 0,
  };

  insertInfo: InsertInfo = {
    insertIndex: -1,
    itemIndex: -1,
    left: 0,
    right: 0,
    isNewLine: false,
    start: 0,
    end: 0,
  };

  curCoord = { left: 0, right: 0, start: 0, end: 0 };
  otherCoord: {
    left: number;
    right: number;
    start: number;
    end: number;
  }[] = [];
  dragElement = null;
  fixPosition = { left: 0, right: 0, start: 0, end: 0 };

  // 行内移动
  moveTrackData = {
    lineIndex: -1,
    itemIndex: -1,
  };

  trackScale = parseInt(localStorage.trackS || "50");
  trackList: TrackLineItem[] = [];
  // 选中元素坐标
  selectTrackItem = {
    line: -1,
    index: -1,
  };
  constructor() {
    makeAutoObservable(this);
  }

  get selectResorce() {
    if (this.selectTrackItem.line === -1) {
      return null;
    }
    return (
      this.trackList[this.selectTrackItem.line]?.list[
        this.selectTrackItem.index
      ] || null
    );
  }

  get showTrackList() {
    return this.trackList.map((line, lineIndex) => {
      // line.main && (mainIndex = lineIndex);
      const newList = line.list.map((item) => {
        const { duration: time } = item.source as VideoSource;
        return {
          ...item,
          showWidth: `${getGridPixel(this.trackScale, item.end - item.start)}px`,
          showLeft: `${getGridPixel(this.trackScale, item.start)}px`,
          time: isVideo(line.type) ? `${formatTime(time || 0).str}` : "",
        };
      });
      return {
        ...line,
        list: newList,
      };
    });
  }

  setEditorConfig(config: EditorConfig) {
    Object.assign(this.editorConfig, config);
  }

  getFrameCount() {
    return this.trackList.reduce((res, { list }) => {
      return Math.max(
        list.reduce((max, track) => Math.max(max, track.end), 0),
        res
      );
    }, 0);
  }

  getFixLine(x: number, distance = 10) {
    // otherCoord.current、游标位置
    // 先获取与拖拽元素left、right，距离小于distance的元素
    const result = [];
    this.otherCoord.forEach((coord) => {
      if (Math.abs(coord.left - x) <= distance) {
        result.push({ position: coord.left, frame: coord.start });
      }
      if (Math.abs(coord.right - x) <= distance) {
        result.push({ position: coord.right, frame: coord.end });
      }
    });
    // 获取与游标位置距离小于distance的元素
    const trackPlayPointX = getGridPixel(
      this.trackScale,
      playerStore.playStartFrame
    );
    if (Math.abs(trackPlayPointX - x) <= distance) {
      result.push({
        position: trackPlayPointX,
        frame: playerStore.playStartFrame,
      });
    }

    return result;
  }

  getComputedPosition(element: HTMLElement) {
    const style = window.getComputedStyle(element);
    return {
      left: parseInt(style.left),
      right: parseInt(style.left) + parseInt(style.width),
    };
  }

  isOverlap(dragItem, line, { start, end }: { start: number; end: number }) {
    if (dragItem.type !== line.type) {
      return { overlap: true, index: 0 };
    }
    // 插入的位置在trackLine中
    const nodes = line.list.filter((item) => item.id !== dragItem.id);
    console.log("nodes", nodes);
    console.log("line.list", line.list);
    console.log("dragItem", dragItem);
    console.log("start,end", start, end);

    if (nodes.length === 0) {
      return { overlap: false, index: 0 };
    }
    // 处理边界问题
    if (nodes[0].start >= end) {
      return { overlap: false, index: 0 };
    }
    if (nodes[nodes.length - 1].end <= start) {
      return { overlap: false, index: nodes.length };
    }
    for (let i = 0; i < nodes.length - 1; i++) {
      const node = nodes[i];
      const preNode = nodes[i + 1];
      console.log("preNode", preNode.right);

      if (start >= node.end && end <= preNode.end) {
        return { overlap: false, index: i + 1 };
      }
    }
    // 当重叠时，创建新行，所以插入位置为0
    return { overlap: true, index: 0 };
  }

  getInsertLineInfo(): {
    isNewLine: boolean;
    insertIndex: number;
    elem?: HTMLElement;
  } {
    console.log(
      "------------",
      this.dragElement.offsetTop,
      this.dragElement.offsetParent.offsetTop
    );

    // 获取拖拽最后的中心点
    const center =
      this.dragElement.offsetTop +
      this.dragElement.offsetHeight / 2 +
      (this.dragElement.offsetParent as HTMLElement).offsetTop;

    console.log("center", center);

    const elems = Array.from(
      document.querySelectorAll(".trackLine")
    ) as HTMLElement[];

    // 处理边界情况
    // 1. center在第一个元素之前
    if (elems[0].offsetTop > center) {
      return { isNewLine: true, insertIndex: 0 };
    }

    for (let i = 0; i < elems.length; i++) {
      const elem = elems[i];
      // center在一个元素中
      if (
        elem.offsetTop <= center &&
        elem.offsetTop + elem.offsetHeight >= center
      ) {
        return { isNewLine: false, insertIndex: i, elem };
      }
      if (i + 1 !== elems.length) {
        const elemNext = elems[i + 1];
        // center在两个元素之间
        if (
          elem.offsetTop + elem.offsetHeight <= center &&
          elemNext.offsetTop >= center
        ) {
          return { isNewLine: true, insertIndex: i + 1 };
        }
      }
    }
    // 2. center在最后一个元素之后
    return { isNewLine: true, insertIndex: elems.length };
  }

  // 获取插入信息
  // insertIndex插入的位置，isNewLine是否插入新行, 插入的位置left、right值，插入行的位置，itemIndex
  getInsertInfo(): InsertInfo {
    // eslint-disable-next-line prefer-const
    let { isNewLine, insertIndex, elem } = this.getInsertLineInfo();

    const style = this.getComputedPosition(this.dragElement);

    const left = this.fixPosition.left || style.left;
    const right = this.fixPosition.right || style.right;

    const start =
      this.fixPosition.start || getSelectFrame(left, this.trackScale, 30);
    const end =
      this.fixPosition.end || getSelectFrame(right, this.trackScale, 30);

    if (!elem) {
      return { insertIndex, itemIndex: 0, left, right, isNewLine, start, end };
    }

    const dragItem = this.dragData.dataInfo;
    const line = this.trackList[insertIndex];

    const { overlap, index: itemIndex } = this.isOverlap(dragItem, line, {
      start,
      end,
    });
    console.log("itemIndex--------", itemIndex);

    // 如果重叠，根据位置判断是插入当前行之前还是之后
    if (overlap) {
      isNewLine = true;
      // 获取elem的中心点
      const center = elem.offsetLeft + elem.offsetWidth / 2;
      if (
        center <
        this.dragElement.offsetTop +
          (this.dragElement.offsetParent as HTMLElement).offsetTop +
          this.dragElement.offsetHeight / 2
      ) {
        insertIndex -= 1;
      }
    }
    return { insertIndex, itemIndex, left, right, isNewLine, start, end };
  }

  insert(insertInfo: InsertInfo) {
    const dragInfo = this.dragData.dataInfo;
    const startFrame = Math.max(
      this.fixPosition.right !== 0
        ? getSelectFrame(insertInfo.right, this.trackScale, 30) -
            (dragInfo.end - dragInfo.start)
        : getSelectFrame(insertInfo.left, this.trackScale, 30),
      0
    );
    // 移动元素到新为止
    dragInfo.end = startFrame + (dragInfo.end - dragInfo.start);
    dragInfo.start = startFrame;
    const newTrackItem = dragInfo;
    // 先根据id将原本的trackItem设置为null
    let deleteLineIndex = 0;
    let deleteItemIndex = 0;
    this.trackList.forEach((lineItem, lineIndex) => {
      lineItem.list.forEach((item, itemIndex) => {
        if (item.id === dragInfo.id) {
          deleteLineIndex = lineIndex;
          deleteItemIndex = itemIndex;
        }
      });
    });
    this.trackList[deleteLineIndex].list.splice(deleteItemIndex, 1);
    if (insertInfo.isNewLine) {
      // 插入新行
      this.trackList.splice(insertInfo.insertIndex, 0, {
        type: newTrackItem.type,
        list: [newTrackItem],
      });
    } else {
      // 插入当前行
      this.trackList[insertInfo.insertIndex].list.splice(
        insertInfo.itemIndex,
        0,
        newTrackItem
      );
    }
    // 删除store.trackList中，list为空的元素
    const deleteIndex = this.trackList.findIndex(
      (lineItem) => lineItem.list.length === 0
    );
    if (deleteIndex !== -1) {
      this.trackList.splice(deleteIndex, 1);
    }
  }

  adsorption(
    { left, right }: { left: number; right: number },
    lines: { position: number; frame: number }[][]
  ) {
    this.fixPosition = { left: 0, right: 0, start: 0, end: 0 };
    if (lines[0].length === 0 && lines[1].length === 0) {
      return;
    }
    // 吸附其实就是移动拖拽元素的位置
    // 找到最近的线，计算移动的距离
    const minLeftLine = lines[0].reduce(
      (r, item) => {
        return Math.abs(item.position - left) < Math.abs(r.position - left)
          ? item
          : r;
      },
      { position: Number.MAX_SAFE_INTEGER, frame: 0 }
    );

    const minRightLine = lines[1].reduce(
      (r, item) => {
        return Math.abs(item.position - right) < Math.abs(r.position - right)
          ? item
          : r;
      },
      { position: Number.MAX_SAFE_INTEGER, frame: 0 }
    );

    if (
      Math.abs(minLeftLine.position - left) <
      Math.abs(minRightLine.position - right)
    ) {
      // 左对齐
      this.fixPosition.left = minLeftLine.position;
      this.fixPosition.start = minLeftLine.frame;

      // trackStateStore.dragData.moveX = minLeftLine.position - curCoord.left;
      this.setDragData({
        moveX: minLeftLine.position - this.curCoord.left,
      });
    } else {
      // 右对齐
      this.fixPosition.right = minRightLine.position;
      this.fixPosition.end = minRightLine.frame;

      this.setDragData({
        moveX: minRightLine.position - this.curCoord.right,
      });
      // trackStateStore.dragData.moveX = minRightLine.position - curCoord.right;
    }
  }

  setDragData(data: any) {
    // this.dragData = { ...this.dragData, ...data };
    Object.assign(this.dragData, data); // 直接修改属性
  }

  setInsertInfo(data: any) {
    // this.insertInfo = {...this.insertInfo,...data };
    Object.assign(this.insertInfo, data); // 直接修改属性
  }

  setMoveTrackData(data: any) {
    Object.assign(this.moveTrackData, data);
  }

  setTrackScale(v: number) {
    this.trackScale = v;
  }

  setSelectTrackItem(item) {
    this.selectTrackItem = { ...this.selectTrackItem, ...item };
  }

  updateTrack(lineIndex, index, data) {
    // console.log("updateTrack", this.trackList[lineIndex].list[index], data);

    // this.trackList[lineIndex].list[index] = {
    //   ...this.trackList[lineIndex].list[index],
    //   ...data,
    // };

    this.trackList[lineIndex].list[index] = Object.create(
      Object.getPrototypeOf(this.trackList[lineIndex].list[index]),
      {
        ...Object.getOwnPropertyDescriptors(
          this.trackList[lineIndex].list[index]
        ),
        ...Object.getOwnPropertyDescriptors(data),
      }
    );

    // console.log(55555, this.trackList[lineIndex].list[index]);
    // Object.assign(this.trackList[lineIndex].list[index], data); // 直接修改属性
  }

  // 删除元素
  removeTrack(lineIndex: number, itemIndex: number) {
    this.trackList[lineIndex].list.splice(itemIndex, 1);
    if (
      this.trackList[lineIndex].list.length === 0 &&
      !this.trackList[lineIndex].main
    ) {
      this.trackList.splice(lineIndex, 1);
    }
    if (this.trackList.length === 1 && this.trackList[0].list.length === 0) {
      this.trackList.splice(0, 1);
    }
  }

  selectTrackById(id: string) {
    this.trackList.forEach((item, index) => {
      item.list.forEach((trackItem, trackIndex) => {
        if (trackItem.id === id) {
          this.selectTrackItem.line = index;
          this.selectTrackItem.index = trackIndex;
        }
      });
    });
  }

  addTrack(newItem: Track) {
    const lines = this.trackList.filter((line) => line.type === newItem.type);

    for (let index = 0; index < lines.length; index++) {
      const line = lines[index];
      const { hasOverlap, insertIndex } = this.checkTrackListOverlap(
        line.list,
        newItem
      );
      if (!hasOverlap) {
        line.list.splice(insertIndex, 0, newItem);
        this.selectTrackItem.line = index;
        this.selectTrackItem.index = insertIndex;
        return;
      }
    }

    if (["audio"].includes(newItem.type)) {
      this.trackList.push({
        type: newItem.type,
        list: [newItem],
      });
      this.selectTrackItem.line = 0;
      this.selectTrackItem.index = 0;
    } else {
      this.trackList.unshift({
        type: newItem.type,
        list: [newItem],
      });
      this.selectTrackItem.line = this.trackList.length - 1;
      this.selectTrackItem.index = 0;
    }
  }

  checkTrackListOverlap(trackList: Track[], checkItem: Track, moveIndex = -1) {
    const { start: insertStart, end: insertEnd } = checkItem;
    let overLapIndex = -1;
    let insertIndex = 0;
    const hasOverlap = trackList.some((trackItem, index) => {
      if (moveIndex !== -1 && index === moveIndex) {
        // 行内移动情况下忽略掉移动元素
        return false;
      }
      const { start, end } = trackItem;
      // 当前列表中元素 开始帧处于新元素内部，或结束帧处于新元素内部，则视为重叠
      if (
        (start <= insertStart && end >= insertEnd) || // 添加节点的开始和结束位置位于老节点外 或 两端相等
        (start >= insertStart && start < insertEnd) || // 老节点开始位置在添加节点内部
        (end > insertStart && end <= insertEnd) // 老节点结束位置在添加节点内部
      ) {
        overLapIndex = index;
        return true;
      } else {
        if (end <= insertStart) {
          insertIndex = index + 1;
        }
        return false;
      }
    });
    return {
      hasOverlap,
      overLapIndex,
      insertIndex,
    };
  }

  adjustVideoTrack() {
    const trackIndex = this.trackList.findIndex(
      (line) => line.type === "video"
    );
    const videoGroups = this.trackList[trackIndex].list;
    let diff = 0;
    this.trackList.forEach((track, trackIndex) => {
      if (track.type === "video") {
        track.list.forEach((group, index) => {
          if (index === 0 && group.start !== 0) {
            console.log("groupo-------------", group);
            diff = group.start;
            this.updateTrack(trackIndex, index, {
              start: 0,
              end: group.end - diff,
            });
          } else if (index > 0) {
            diff = group.start - videoGroups[index - 1].end;
            this.updateTrack(trackIndex, index, {
              start: videoGroups[index - 1].end,
              end: group.end - diff,
            });
          }
        });
      } else {
        track.list.forEach((group, index) => {
          this.updateTrack(trackIndex, index, {
            start: Math.max(group.start, 0),
            end: group.frameCount + Math.max(group.start, 0),
          });
        });
      }
    });
  }

  resetState() {
    playerStore.setPause(true);

    const trackItemList = getCurrentEditorTrackItemList(
      this.trackList,
      playerStore.playStartFrame,
      isOfCanPlayEditorType
    );
    trackItemList.forEach((item) => {
      item?.pause();
    });

    playerStore.setPlayStartFrame(0);

    this.insertInfo = {
      insertIndex: -1,
      itemIndex: -1,
      left: 0,
      right: 0,
      isNewLine: false,
      start: 0,
      end: 0,
    };
    this.dragData = {
      dataInfo: {} as any,
      dragType: "",
      dragPoint: {
        x: 0,
        y: 0,
      },
      // 吸附辅助线
      fixLines: [] as { position: number; frame: number }[][],
      moveX: 0,
      moveY: 0,
    };
    this.curCoord = { left: 0, right: 0, start: 0, end: 0 };
    this.otherCoord = [];
    this.dragElement = null;
    this.fixPosition = { left: 0, right: 0, start: 0, end: 0 };
    this.moveTrackData = {
      lineIndex: -1,
      itemIndex: -1,
    };
    this.selectTrackItem = {
      line: -1,
      index: -1,
    };
    this.trackScale = parseInt(localStorage.trackS || "40");
    this.trackList = [];
  }
}

const trackState = new TrackState();
export default trackState;
